export const updateFilters = (state, payload) => {
    state.filters[payload.object_key] = { ...state.filters[payload.object_key], [payload.key]: payload.value };
}

export const updatePhoneNumber = (state, payload) => {
    state.support.tel = payload;
}

export const updateQuotation = (state, payload) => {
    state.support.quotations = payload;
}

/*
 * Authentication
 */

export const updateToken = (state, payload) => {
    state.auth.token = payload;
}

export const logout = (state) => {
    state.auth.token = '';
}

export const updateOTPExpiration = (state, payload) => {
    state.support.OTPExpiration = payload;
}

export const updateUserId = (state, payload) => {
    state.support.user_id = payload;
}
